import { dew as _getHeaderDew } from "./getHeader";
import { dew as _StreamingFetcherDew } from "./StreamingFetcher";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.streamingFetcher = exports.getHeader = void 0;
  var getHeader_1 = _getHeaderDew();
  Object.defineProperty(exports, "getHeader", {
    enumerable: true,
    get: function () {
      return getHeader_1.getHeader;
    }
  });
  var StreamingFetcher_1 = _StreamingFetcherDew();
  Object.defineProperty(exports, "streamingFetcher", {
    enumerable: true,
    get: function () {
      return StreamingFetcher_1.streamingFetcher;
    }
  });
  return exports;
}